'use strict';

export default '0.10.2';